import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Search } from 'lucide-react';

/**
 * BackToSearch Component
 * Shows a "Back to Search Results" link if user came from a search
 * Uses sessionStorage to remember the last search query and URL
 */
export function BackToSearch({ className = '' }) {
  const navigate = useNavigate();
  const lastSearchQuery = sessionStorage.getItem('lastSearchQuery');
  const lastSearchUrl = sessionStorage.getItem('lastSearchUrl');

  if (!lastSearchQuery) return null;

  const handleBack = () => {
    if (lastSearchUrl) {
      // Navigate to the stored search URL
      window.location.href = lastSearchUrl;
    } else {
      // Fallback to directory search with query
      navigate(`/directory/search?q=${encodeURIComponent(lastSearchQuery)}`);
    }
  };

  return (
    <button
      onClick={handleBack}
      className={`inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 text-sm transition-colors group ${className}`}
      data-testid="back-to-search-btn"
    >
      <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
      <Search className="w-3 h-3" />
      <span>Back to search: "<span className="font-medium">{lastSearchQuery}</span>"</span>
    </button>
  );
}

/**
 * Clear the stored search when user starts a new session or navigates away
 */
export function clearSearchHistory() {
  sessionStorage.removeItem('lastSearchQuery');
  sessionStorage.removeItem('lastSearchUrl');
}

export default BackToSearch;
